var exports = {
  "wrapper": "x24da60e8--655ae8--wrapper",
  "full-with": "x24da60e8--655ae8--full-with",
  "fill_secondary": "x24da60e8--655ae8--fill_secondary",
};

module.exports = exports;
